import { t } from "i18next";

import { Box, ListItem, Typography } from "@mui/material";

import { isDarkMode } from "@/src/theme/helpers";
import { schemeSx } from "@/src/theme/schemeStyles";

import {
  CONSUMER_HOMEPAGE_PREFIX,
  HOMEPAGE_FRONT_PAGE_CONTAINER_STYLES,
  HOMEPAGE_SECTION_TITLE_SX
} from "@/src/pages/consumer/HomePage/homePage.constants";

import { VehicleType } from "@/src/types/types";

interface HomePageDescriptionProps {
  vehicleType: VehicleType;
}

const DESCRIPTION_LIST_ITEM_INDEXES = [1, 2, 3] as const;
const CHECKMARK_IMAGE = "url('/assets/images/checkmark.webp')";

export const HomePageDescription = ({
  vehicleType
}: HomePageDescriptionProps) => {
  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        ...HOMEPAGE_FRONT_PAGE_CONTAINER_STYLES,
        // The Katsastus banner below shares the background, so keep the gap
        // short (the list items add 8px). Overrides must be responsive like
        // the shared py, otherwise its media queries win.
        pb: { xs: 7, lg: 8 }
      }}
    >
      <Box>
        <Typography variant="h2" sx={HOMEPAGE_SECTION_TITLE_SX}>
          {t(`${CONSUMER_HOMEPAGE_PREFIX}.${vehicleType}.descriptionHeader`)}
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: ["column", "column", "row"]
          }}
        >
          {DESCRIPTION_LIST_ITEM_INDEXES.map((item) => (
            <ListItem
              key={`descriptionListItem-${item}`}
              sx={{
                pl: 0
              }}
            >
              <Box
                sx={schemeSx((theme) => ({
                  "&:before": {
                    content: "''",
                    display: "block",
                    minHeight: "25px",
                    minWidth: "25px",
                    marginRight: 2,
                    fontStyle: "normal",
                    ...(isDarkMode(theme)
                      ? {
                          // Recolor the raster checkmark by using it as a mask
                          backgroundColor: theme.palette.semantic.success.light,
                          maskImage: CHECKMARK_IMAGE,
                          maskSize: "100% auto",
                          maskPosition: "top",
                          maskRepeat: "no-repeat"
                        }
                      : {
                          backgroundImage: CHECKMARK_IMAGE,
                          backgroundSize: "100% auto",
                          backgroundPosition: "top",
                          backgroundRepeat: "no-repeat"
                        })
                  }
                }))}
              />
              {t(
                `${CONSUMER_HOMEPAGE_PREFIX}.${vehicleType}.descriptionListItem-${item}`
              )}
            </ListItem>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
